export type CoachPersona = {
  id: string;
  name: string;
  title: string;
  headline?: string;
  helpsAnswer?: string[];
  bio?: string;
  modelHint: string;
  color: string;
  avatar: string;
  highlightTags?: string[];
};

export const coachPersonas: CoachPersona[] = [
  {
    id: "rajesh",
    name: "Rajesh",
    title: "Leadership Coach",
    headline: "Executive coach (20+ yrs): Influence & Impact",
    helpsAnswer: [
      "How am I showing up as a leader?",
      "How do I lead people better?",
      "How do my actions impact others?"
    ],
    modelHint: "rohan",
    color: "from-orange-500 to-amber-500",
    avatar: "Rajesh-pic.jpg",
    highlightTags: ["Executive Presence & Influence", "Leading Self and Others", "Decision Making", "Culture and values in action"],
  },
  {
    id: "samuel",
    name: "Samuel",
    title: "Performance Coach",
    headline: "Outcome-first coaching; Results & Execution",
    helpsAnswer: [
      "How do I get better results?",
      "Why am I stuck?",
      "How do I execute consistently?"
    ],
    modelHint: "samuel",
    color: "from-blue-500 to-cyan-500",
    avatar: "Samuel-pic.jpg",
    highlightTags: ["'Prioritization and goal achievement", "Productivity", "Effectiveness at Work"],
  },
  {
    id: "priya",
    name: "Priya",
    title: "Career Coach",
    headline: "Career strategist: Direction & growth",
    helpsAnswer: [
      "What's my next move?",
      "Am I on the right path?",
      "How do I grow my career intentionally?"
    ],
    modelHint: "maya",
    color: "from-rose-500 to-pink-500",
    avatar: "Priya_Career_Coach_Avatar_ca2e0841.png",
    highlightTags: ["Career Direction", "Role Fit", "Growth Opportunities", "Career decisions and dilemmas"],
  },
  {
    id: "meera",
    name: "Meera",
    title: "Transition Coach",
    headline: "Transition specialist: Change & Renewal",
    helpsAnswer: [
      "Role changes",
      "New leadership positions",
      "Career shifts",
      "Personal transitions"
    ],
    modelHint: "aria",
    color: "from-purple-500 to-indigo-500",
    avatar: "Meera_HiPo_Coach_Avatar_c4738f33.png",
    highlightTags: ["Role changes", "New Leadership Positions", "Career Shifts", "Personal Transitions"],
  },
  {
    id: "aisha",
    name: "Aisha",
    title: "Life Coach",
    headline: "Whole-person coaching: Balancing & Meaning",
    helpsAnswer: [
      "I feel overwhelmed",
      "Something feels off",
      "How do I live more intentionally?"
    ],
    modelHint: "zara",
    color: "from-emerald-500 to-teal-500",
    avatar: "Aisha-pic.jpg",
    highlightTags: ["Overall Life Balance", "Well being", "Values alignment beyond work"],
  },
  {
    id: "arjun",
    name: "Arjun",
    title: "EmpathEAR Coach",
    headline: "EmpathEAR: Listening Partner",
    helpsAnswer: [
      "Does not interrupt, coach, or advise in real time"
    ],
    modelHint: "arjun",
    color: "from-slate-600 to-slate-800",
    avatar: "Arjun_EmpathEAR_Coach_Avatar_34714366.png",
    highlightTags: ["Speak Freely", "Feel Heard", "Share thoughts and feelings"],
  },
];
